import React from "react";
import { altColor, secondaryTextColorOppositeShade } from "../../utils/constants";

export default function NewQuizInfoIcon({ color = altColor, color2 = secondaryTextColorOppositeShade }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 546.64 546.64">
      <defs>
        <radialGradient
          id="Unbenannter_Verlauf_3"
          cx="273.32"
          cy="-1878.29"
          r="270.56"
          gradientTransform="matrix(1, 0, 0, -1, 0, -1604.97)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color={color} />
          <stop offset="1" stop-color={color} />
        </radialGradient>
      </defs>
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Capa_1" data-name="Capa 1">
          <g id="Ebene_2-2" data-name="Ebene 2">
            <g id="Ebene_1-2" data-name="Ebene 1-2">
              <circle
                stroke={color}
                strokeMiterlimit="10"
                strokeWidth="5.51px"
                fill="url(#Unbenannter_Verlauf_3)"
                cx="273.32"
                cy="273.32"
                r="270.56"
              />
            </g>
          </g>
          <path
            fill={color2}
            d="M223.64,407.53a49.58,49.58,0,1,0,99.15,0v-41a84.1,84.1,0,0,1,25.95-60.31,108.75,108.75,0,0,0,31.88-97.77,109.1,109.1,0,1,0-210.69,54.29,109.75,109.75,0,0,0,27.76,43.48,84.09,84.09,0,0,1,25.95,60.29Zm-12.22-115.6c-21.76-20.89-31.26-50.07-26.07-80.08,7.36-42.51,44.31-73.36,87.87-73.36s80.51,30.85,87.86,73.36c5.19,30-4.31,59.19-26.07,80.08a104.35,104.35,0,0,0-31.55,64.7H243a104.41,104.41,0,0,0-31.56-64.69ZM303,376.46v31.07a29.75,29.75,0,1,1-59.49,0V376.45Z"
          />
          <path
            fill={color2}
            d="M273.22,179A35.25,35.25,0,0,0,238,214.17a11.74,11.74,0,1,0,23.47,0,11.74,11.74,0,1,1,15.7,11.06,23.73,23.73,0,0,0-15.7,22.28v1.87a11.74,11.74,0,0,0,23.47,0v-1.87a.21.21,0,0,1,.14-.19A35.21,35.21,0,0,0,273.22,179Z"
          />
          <circle fill={color2} cx="273.22" cy="284.58" r="11.73" />
          <rect fill={color2} x="103.99" y="217.81" width="40.36" height="19.83" rx="9.92" />
          <rect
            fill={color2}
            x="115.85"
            y="159.96"
            width="40.36"
            height="19.83"
            rx="9.92"
            transform="translate(159.96 -46.43) rotate(45)"
          />
          <rect
            fill={color2}
            x="116.06"
            y="275.43"
            width="40.36"
            height="19.83"
            rx="9.92"
            transform="translate(-161.87 179.91) rotate(-45)"
          />
          <rect
            fill={color2}
            x="402.28"
            y="217.93"
            width="40.36"
            height="19.83"
            rx="9.92"
            transform="translate(844.93 455.69) rotate(180)"
          />
          <rect
            fill={color2}
            x="390.42"
            y="160.08"
            width="40.36"
            height="19.83"
            rx="9.92"
            transform="translate(821.15 -0.15) rotate(135)"
          />
          <rect
            fill={color2}
            x="390.22"
            y="275.55"
            width="40.36"
            height="19.83"
            rx="9.92"
            transform="translate(498.74 777.51) rotate(-135)"
          />
        </g>
      </g>
    </svg>
  );
}
